import React from "react";
import Finance from "@/pages/admin/Finance";
import { useAuth } from "@/contexts/AuthContext";

// Management USA NJ — completely isolated ledger from the pool-supply
// business. Reuses the Finance UI but every expense / payroll / P&L call
// is scoped to `ledger="mgmt_usa_nj"` (the backend pins mgmt tenants to
// their OWN books automatically). Tenant logins see their business name.
export default function ManagementUsaNJ() {
  const { user } = useAuth();
  const isTenant = user && (user.role === "mgmt" || user.is_mgmt === true);
  const title = isTenant ? (user.business_name || user.name || "My business") : "Management USA NJ";
  const subtitle = isTenant
    ? "Your own books — tickets, expenses, payroll, colonies and workers. Completely separate from everyone else."
    : "Separate books — expenses and payroll for the Management USA NJ business. Not linked to pool invoices, tickets, or the shared bank feed.";
  return (
    <div data-testid="mgmt-usa-nj-page">
      <Finance
        ledger="mgmt_usa_nj"
        pageTitle={title}
        pageSubtitle={subtitle}
        showCards={false}
      />
    </div>
  );
}
